(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["customer-experience-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
    const money = (cents) => `Dhs. ${(cents / 100).toFixed(cents % 100 === 0 ? 0 : 2)}`;

    const installProductBenefits = () => {
      const template = document.querySelector('#cx-product-benefits-template');
      const buttons = document.querySelector('.product-form__buttons');
      if (!template || !buttons || document.querySelector('[data-cx-product-benefits]')) return;
      buttons.insertAdjacentElement('afterend', template.content.firstElementChild.cloneNode(true));
    };

    const installIncludedDetails = () => {
      const labels = document.querySelector('#cx-product-labels');
      const title = document.querySelector('.product__title')?.textContent || document.title;
      const description = document.querySelector('.product__description');
      if (!labels || !description || description.closest('.cx-included-details')) return;
      if (!/xbloom/i.test(title) || !/(organizer|accessory)/i.test(title)) return;
      const details = document.createElement('details');
      details.className = 'cx-included-details';
      const summary = document.createElement('summary');
      summary.textContent = labels.dataset.whatsIncluded;
      description.before(details);
      details.append(summary, description);
    };

    const disableUnavailableColors = () => {
      document.querySelectorAll('.product-form__input').forEach((fieldset) => {
        const legend = fieldset.querySelector('legend')?.textContent.trim().toLowerCase() || '';
        if (!legend.startsWith('color') && !legend.startsWith('اللون')) return;
        fieldset.querySelectorAll("input[type='radio'].disabled").forEach((input) => {
          input.disabled = true;
          input.setAttribute('aria-disabled', 'true');
        });
      });
    };

    const syncSelectedMedia = (input) => {
      window.setTimeout(() => {
        const picker = input.closest('variant-selects');
        const sectionId = picker?.dataset.section;
        const gallery = document.querySelector(`media-gallery[id*='${sectionId}']`) || document.querySelector('media-gallery');
        if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
        let mediaId;
        try {
          mediaId = JSON.parse(picker.querySelector('[data-selected-variant]')?.textContent || '{}').featured_media?.id;
        } catch (error) {}
        if (!mediaId) {
          const color = input.value.toLowerCase();
          const image = Array.from(document.querySelectorAll('.product__media img')).find((item) =>
            (item.alt || '').toLowerCase().includes(color)
          );
          mediaId = image?.closest('[data-media-id]')?.dataset.mediaId?.split('-').pop();
        }
        if (mediaId) gallery.setActiveMedia(`${sectionId}-${mediaId}`, true);
      }, 650);
    };

    const installStickyAdd = () => {
      if (window.innerWidth > 749) return;
      const original = document.querySelector('.product-form__submit');
      if (!original) return;
      let bar = document.querySelector('.cx-mobile-add');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'cx-mobile-add';
        const stickyButton = document.createElement('button');
        stickyButton.type = 'button';
        stickyButton.className = 'button button--primary';
        stickyButton.addEventListener('click', () => document.querySelector('.product-form__submit')?.click());
        bar.append(stickyButton);
        document.body.append(bar);
      }
      const button = bar.querySelector('button');
      const refresh = () => {
        const currentButton = document.querySelector('.product-form__submit');
        if (!currentButton) return;
        button.textContent = currentButton.querySelector('span')?.textContent.trim() || currentButton.textContent.trim();
        button.disabled = currentButton.disabled;
      };
      refresh();
      if (bar.cxObservedButton !== original) {
        bar.cxVisibilityObserver?.disconnect();
        bar.cxVisibilityObserver = new IntersectionObserver(([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting), {
          threshold: 0.15,
        });
        bar.cxVisibilityObserver.observe(original);
        bar.cxObservedButton = original;
      }
    };

    const installCartProgress = () => {
      const template = document.querySelector('#cx-cart-progress-template');
      const blocks = document.querySelector('#main-cart-footer .cart__blocks');
      if (!template || !blocks || blocks.querySelector('[data-cx-cart-progress]')) return;
      blocks.prepend(template.content.firstElementChild.cloneNode(true));
      updateCartProgress();
    };

    let updatingCart = false;
    const updateCartProgress = async () => {
      const panel = document.querySelector('[data-cx-cart-progress]');
      if (!panel || updatingCart) return;
      updatingCart = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        const currentCart = await response.json();
        const threshold = Number(panel.dataset.threshold);
        const remaining = Math.max(threshold - currentCart.total_price, 0);
        panel.querySelector('[data-cx-progress-message]').textContent =
          remaining === 0 ? panel.dataset.complete : panel.dataset.remaining.replace('__AMOUNT__', money(remaining));
        panel.querySelector('[data-cx-progress-bar]').style.setProperty(
          '--cx-progress',
          `${Math.min((currentCart.total_price / threshold) * 100, 100)}%`
        );
      } catch (error) {}
      updatingCart = false;
    };

    const installAll = () => {
      installProductBenefits();
      installIncludedDetails();
      disableUnavailableColors();
      installStickyAdd();
      installCartProgress();
    };

    document.addEventListener('change', (event) => {
      const input = event.target.closest("variant-selects input[type='radio']");
      if (input) syncSelectedMedia(input);
      if (event.target.closest('cart-items')) window.setTimeout(updateCartProgress, 500);
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installAll);
    else installAll();

    let observerTimer;
    new MutationObserver(() => {
      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(installAll, 120);
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
